
import PropTypes from 'prop-types'
import React from 'react'
import Switch from './Switch'
import ShowHide from './ShowHide'
import './SwitchField.css'

const SwitchField = props => {
  const { label, checked, hint, onChange, disabled, switchText } = props

  return (
    <div className='SwitchField'>
      <div className='SwitchField-field'>
        <div className='SwitchField-label'>
          {label}
        </div>
        <div className='SwitchField-switchRight'>
          <span className='SwitchField-switchText'>
            {switchText}
          </span>
          <div className='SwitchField-switch'>
            <Switch checked={checked} disabled={disabled} onChange={onChange} />
          </div>
        </div>
      </div>
      <ShowHide show={hint}>
        <div className='SwitchField-hint' dangerouslySetInnerHTML={{ __html: hint }} />
      </ShowHide>
    </div>
  )
}

SwitchField.displayName = 'SwitchField'

SwitchField.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  hint: PropTypes.string,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  switchText: PropTypes.string
}

export default SwitchField



// WEBPACK FOOTER //
// ./ui/SwitchField.js